export default __webpack_public_path__ + "static/find-illus-2c16172347dd56125272c156709cb1c3.svg";